import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css";
import style from "../css/ImportSection.module.css";
import Button from "@material-ui/core/Button";
// import RedCross from "../../../Icons/RedCross";
import RedCross from "../../Icons/RedCross";
import { removeAndUpdateIndex } from "../../components/IFormDesignerLayout/SectionLayoutLogic";
import { useDispatch, addContexts, useSelector } from "../../Redux";
import { getFormId, sendRequestForControl } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import { updateRowNColumn } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import { useTranslation } from "react-i18next";
import {ThemeJSON} from "../../components/IFormDesignerLayout/Theme/ThemeJSON";
import axios from "../../axios";
import { recursiveJsonReader1 } from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import { isObjectEmpty } from "../../Resources/globalFunctions";
import { GetStateFromData } from "../../components/CustomHooks/CustomHooks";
import { Dialog } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 200,
    color: "#fff",
  },
}));

function ImportSection(props) {
  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId,"data2");

  const {
    advanceListviewStateJson
  } = gridContexts.gridStates;

  const { t } = useTranslation();

  const {
    recursiveJsonForImportSection,
    setOpenLoader,
    formState2,
    showAlertConfirmNotifications,
    openCanvasForSubform,
    currentButtonForSubform,
    subFormStateJson,
    // advanceListviewStateJson,
    updateJson,
    setAlertData,
    microFrontendData,
    activePage,
    activeSubForm,
    // setGlobalLoading,
    // setGlobalLoadingMessage,
  } = contexts.contexts;
  const { updatedComponentInFormState } = updateJson;
  function cancelImport() {
    //  props.setopenClose(1);
    props.setShowImportSectionPopUp(false);
    props.setIsTableUpload(false);
    //  console.log("showImportSectionPopUp cancel");
  }

  function testinghandlerImport(e) {
    //  console.log("showImportSectionPopUp test");
    e.stopPropagation();
  }
  useEffect(()=>{
    document.getElementById("backdropDiv")?.focus();
    
   },[])
  function handleEscapeKey(e){
    if(e.code === "Escape"){
      cancelImport()
    } 
   }

  const [propertyName, setpropertyName] = useState(
    props.isTableUpload ? "replace" : "new"
  );

  
  let importedControl = props?.data?.elem_type;

  useEffect(()=>{
    if(importedControl === "table" || importedControl === "listview"){
      setpropertyName("replace")
    }
    
  },[])

  function sectionAddOrReplace(propertyName) {
    if (propertyName !== null) {
      setpropertyName("");
    }
    setpropertyName(propertyName);
    //  console.log("propertyName ",propertyName);
  }

  const parentWizard = (controlId) => {
    if (
      document
        .getElementById(`${controlId}`)
        ?.closest(`[elem_type=wizard_v]`) ||
      document
        .getElementById(`${controlId}`)
        ?.closest(`[elem_type=wizard_h]`) ||
      (document
        .getElementById(`${controlId}`)
        ?.closest(`[elem_type=sidenavigation]`) &&
        !document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const parentMenuCheck = (controlId) => {
    if (document.getElementById(`${controlId}`)?.closest(`[elem_type=Menu]`)) {
      return true;
    } else {
      return false;
    }
  };

  const parentTab = (controlId) => {
    if (document.getElementById(`${controlId}`)?.closest(`[elem_type=tab]`)) {
      return true;
    } else {
      return false;
    }
  };

  async function importSection() {
    window.loading(true)
    if (props.isTableUpload) {
      //deleted element
      let remainingURL;
      let stepIndex;
      let subStepIndex;
      let subChildMenuIndex;
      let isMenu = document
        .querySelector(`#${props.data.id}`)
        ?.closest(`[elem_type=Menu]`);
      let isWizard = document
        .querySelector(`#${props.data.id}`)
        ?.closest(`[elem_type=Menu]`);
      if (formState2?.isStep && formState2?.isStep?.insideWizard) {
        remainingURL = "/Properties/addColumnInStep";
        stepIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("stepIndex");
        subStepIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("substepindex");
        subChildMenuIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("subchildmenuindex");
      } else if (isMenu) {
        stepIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("stepIndex");
        subStepIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("substepindex");
        subChildMenuIndex = document
          .querySelector(`#${props.data.id}`)
          ?.closest(`main`)
          ?.getAttribute("subchildmenuindex");
        remainingURL = "/Properties/addColumnInStep";
      } else {
        remainingURL = "/Properties/addColumn";
      }
      if (parentWizard(props.data.id)) {
        props.data.insideWizard = true;
        props.data.parentStep = formState2?.isStep?.parentStep;
        props.data.parentSubStep = formState2?.isStep?.parentSubStep;
        props.data.subChildMenuIndex = subChildMenuIndex;
      }
      if (parentMenuCheck(props.data.id)) {
        let stepIndex = document
          .getElementById(`${props.data.id}`)
          .closest("main")
          .getAttribute("stepindex");
        let subStepIndex = document
          .getElementById(`${props.data.id}`)
          .closest("main")
          .getAttribute("substepindex");
        let subChildMenuIndex = document
          .getElementById(`${props.data.id}`)
          .closest("main")
          .getAttribute("subchildmenustepindex");
        props.data.insideMenu = true;
        props.data.stepIndex = stepIndex;
        props.data.subChildMenuIndex = subStepIndex;
        props.data.subStepIndex = subChildMenuIndex;
      }
      if (parentTab(props.data.id)) {
        props.data.insideTab = true;
      }
      props.data.isUpload = true;
      sendRequestForControl(
        props.data.frameIndex,
        "delete",
        "table",
        props.data
      ).then((response) => {
        if (response.data.status === 0) {
          if (openCanvasForSubform === "subform") {
            var updatedformState = removeAndUpdateIndex(
              subFormStateJson,
              props.data
              // "table",
              // 1,
              // response.data
            );
            updatedComponentInFormState();
          } else if (openCanvasForSubform === "advanceListviewFromScratch") {
            var updatedformState = removeAndUpdateIndex(
              advanceListviewStateJson,
              props.data
              // "table",
              // 1,
              // response.data
            );
            updatedComponentInFormState();
          } else {
            // console.log("updatedformState updatedformState ");
            if (
              props.data.elem_type === "tab" &&
              !document
                .getElementById(props.data.id)
                ?.closest(`[elem_type=section]`)
            ) {
              const parentFrameId =
                document
                  .querySelector(`#${props.data.id}`)
                  ?.parentElement?.getAttribute("parentframeid") ||
                document
                  .querySelector(`#${props.data.id}`)
                  ?.parentElement?.getAttribute("parentFrameId");

              props.data["id"] = parentFrameId;
              sendRequestForControl(
                response.data.frameIndex,
                "delete",
                "frame",
                props.data
              )
                .then((res) => {
                  if(res.data.status === 0){
                  var updatedformState = removeAndUpdateIndex(
                    formState2,
                    parentFrameId,
                    "frame",
                    1,
                    res.data
                  );
                  updatedComponentInFormState();
                  }
                  else if(res.data.status === 1){
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey:"Reopen_Form",
                    });
                  }
                })
                .catch((err) => {
                  console.log(err);
                    window.loading(false)
                });
            } else {
              var updatedformState = removeAndUpdateIndex(
                formState2,
                props.data
                // props.data.elem_type,
                // 1,
                // response.data
              );
              updatedComponentInFormState();
            }

            //setFormState2(updatedformState);
          }
        } 
        else if(response.data.status === 1){
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey:"Reopen_Form",
          });
        }
        else {
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: "Failed to delete control. Please try again.",
            autoHideDuration: 6000,
          });
        }
      })
      .catch((error) => {
        window.loading(false)
      })
      //addElement
      let stepIndex1 = document
        .getElementById(`${props.data.id}`)
        ?.closest("main")
        ?.getAttribute("stepindex");
      let subStepIndex1 = document
        .getElementById(`${props.data.id}`)
        ?.closest("main")
        ?.getAttribute("substepindex");
      let subChildMenuIndex1 = document
        .getElementById(`${props.data.id}`)
        ?.closest("main")
        ?.getAttribute("subchildmenustepindex");
      let jsonToSend = {
        controlName: "table",
        elem_type: "table",
        frameIndex: props.data.frameIndex,
        isAdvanceListview: props?.data?.isAdvanceListview,
        isSubform: props?.data?.isSubForm,
        stepIndex: formState2?.isStep?.parentStep || stepIndex1,
        subStepIndex: formState2?.isStep?.parentSubStep || subStepIndex1,
        subChildMenuIndex:
          formState2?.isStep?.subChildMenuIndex || subChildMenuIndex1,
      };
      let addURL = "/idesign/addElement";
      let opType = 1;
      if (parentWizard(props.data.id) || parentMenuCheck(props.data.id)) {
        addURL = "/idesign/addElementInStep";
        opType = 2
      }
      if (parentTab(props.data.id)) {
        let insideFrame = document
          .getElementById(`${props.data.id}`)
          ?.closest(`[elem_type=frame]`);
        if (insideFrame) {
          addURL = "/idesign/addNewElementToTabSheetFrame";
          opType = 4
        } else {
          addURL = "/idesign/addNewElementToTabSheet";
          opType = 3
        }
        jsonToSend.sheetId = props.data.sheetIndex;
        jsonToSend.elementIndex = "0";
        jsonToSend.sheetElementIndex = props.data.sheetElementIndex;
      }
      jsonToSend.opType = opType
      let formId = getFormId();
      jsonToSend.formId = formId;
      let response = await axios
        .post(addURL, jsonToSend, {
          withCredentials: true,
        })
        .then((response) => {
          let eleJson = recursiveJsonReader1(
            formState2,
            props.currentColumn,
            "column"
          );
          props.uploadedJson.id = response.data.id;
          props.uploadedJson.frameIndex = response.data.frameIndex;
          props.uploadedJson.elementIndex = response.data.elementIndex;
          // props.uploadedJson.style.Label = response.data.id;
          eleJson.children.push(props.uploadedJson);
          console.log("sdadadsa", eleJson);
          updatedComponentInFormState();
          // add uploadedJson in children

          let columnList = [];
          for (let item of props.uploadedJson.columnList) {
            let styleObj = item.style;
            styleObj["FormId"] = `${
              microFrontendData?.formDefId ||
              activePage?.formId ||
              activeSubForm?.fragmentId ||
              microFrontendData?.formId
            }`;
            styleObj["frameIndex"] = props.data.frameIndex;
            styleObj["elementIndex"] = response.data.elementIndex;
            styleObj["elem_type"] = "column";
            styleObj["stepIndex"] = formState2?.isStep?.parentStep || stepIndex || -1;
            styleObj["subStepIndex"] = formState2?.isStep?.parentSubStep || -1;
            styleObj["subChildMenuIndex"] =
              subChildMenuIndex || subChildMenuIndex == 0
                ? subChildMenuIndex
                : "-1";
            columnList.push(item.style);
          }
          let type = 1;
          if(props.data.sheetElementIndex && !props.data.sheetFrameElementIndex){
            type = 2
          }else if(props.data.sheetElementIndex && props.data.sheetFrameElementIndex){
            type = 3
          }else if(props.data?.containerControl==="wizard_h" || props.data?.containerControl==="wizard_v" || props.data?.containerControl === "sidenavigation" || props?.data?.containerControl?.toLowerCase() === "menu"){
            type = 4
          }
          // if (formState2?.isStep?.insideWizard) {
          //   type = 3;
          // }
          // if (parentMenuCheck(response.data.id)) {
          //   type = 4;
          // }
          // if (parentTab(response.data.id)) {
            // type = 4;
          // }
          let columnJson = {}
          if(type === 4){
            for(let item of columnList){
              item.type = "menu"
            }
            columnJson = {
              columns: [...columnList],
              type: type,
              controlid: response.data.id,
            };
          }else{
            columnJson = {
              columns: [...columnList],
              type: type,
              controlid: response.data.id
            };
          }
            
          axios
            .post("Properties/addColumnsInTable", columnJson, {
              withCredentials: true,
            })
            .then((response) => {
              window.loading(false)
              console.log("columnResponse", response);
            });
        });
    } else {
      var populateInside = {};
      if (props?.data?.sheetElementIndex) {
        populateInside = {
          ...populateInside,
          frameIndex: props?.data?.frameIndex,
          elementIndex: props?.data?.elementIndex,
          sheetId: props?.data?.sheetIndex,
          elem_type: "sheet",
        };
      } else {
        populateInside = {
          ...populateInside,
          elem_type: "form",
          id: "RootControl",
        };
      }
      if (propertyName === "replace") {
        populateInside = {
          ...populateInside,
          replacedFrameIndex: props?.data?.sheetElementIndex
            ? props?.data?.sheetElementIndex
            : props?.data?.frameIndex,
        };
      }
      //   if(propertyName==="replace")
      //   {
      //   // populateInside = {
      //   //   id: props.data["id"],
      //   //   elem_type: props.data["elem_type"],
      //   //   frameIndex: props.data["frameIndex"],
      //   //   elementIndex: props.data["elementIndex"],
      //   //   sheetElementIndex: props.data["sheetElementIndex"],
      //   //   sheetFrameElementIndex: props.data["sheetFrameElementIndex"],
      //   //   sheetId: props.data["sheetIndex"],
      //   // }

      //   populateInside ={id: "RootControl", elem_type: "form"}
      // }else if(propertyName==="new"){

      //   populateInside ={id: "RootControl", elem_type: "form"}
      //   // populateInside = {
      //   //   id: props.data["id"],
      //   //   elem_type: props.data["elem_type"],
      //   //   frameIndex: props.data["frameIndex"],
      //   //   elementIndex: props.data["elementIndex"],
      //   //   sheetElementIndex: props.data["sheetElementIndex"],
      //   //   sheetFrameElementIndex: props.data["sheetFrameElementIndex"],
      //   //   sheetId: props.data["sheetIndex"],
      //   // }

      // }
      if(props.data?.containerControl?.toLowerCase() === "wizard_h" || props.data?.containerControl?.toLowerCase() === "sidenavigation" || props.data?.containerControl?.toLowerCase() === "wizard_v" || props?.data?.containerControl?.toLowerCase() === "menu"){
        if(props?.data?.stepIndex || props?.data?.stepIndex === 0)
          populateInside["stepIndex"] = props?.data?.stepIndex
        if(props?.data?.subStepIndex || props?.data?.subStepIndex === 0)
          populateInside["subStepIndex"] = props?.data?.subStepIndex
        if(props?.data?.subChildMenuIndex || props?.data?.subChildMenuIndex === 0)
          populateInside["subChildMenuIndex"] = props?.data?.subChildMenuIndex
          populateInside["id"] = "wizard"
        if(props?.data?.containerControl?.toLowerCase() === "menu")
          populateInside["elem_type"] = "Menu"
        if(props?.data?.containerControl === "wizard_h")
          populateInside["elem_type"] = "wizard_h"
        if(props?.data?.containerControl === "wizard_v")
          populateInside["elem_type"] = "wizard_v"
        if(props?.data?.containerControl === "sidenavigation")
          populateInside["elem_type"] = "sidenavigation"
        if (openCanvasForSubform === "subform") {
          if (
            currentButtonForSubform.stepIndex ||
            currentButtonForSubform.stepIndex === 0
          )
            populateInside["stepIndex"] = currentButtonForSubform.stepIndex;
          if (
            currentButtonForSubform.subStepIndex ||
            currentButtonForSubform?.subStepIndex === 0
          )
            populateInside["subStepIndex"] =
              currentButtonForSubform?.subStepIndex;
          if (
            currentButtonForSubform.subChildMenuIndex ||
            currentButtonForSubform?.subChildMenuIndex === 0
          )
            populateInside["subChildMenuIndex"] =
              currentButtonForSubform.subChildMenuIndex;
        }
        if (openCanvasForSubform === "advanceListviewFromScratch") {
          if (
            advanceListviewStateJson.stepIndex ||
            advanceListviewStateJson.stepIndex === 0
          )
            populateInside["stepIndex"] = advanceListviewStateJson.stepIndex;
          if (
            advanceListviewStateJson.subStepIndex ||
            advanceListviewStateJson?.subStepIndex === 0
          )
            populateInside["subStepIndex"] =
            advanceListviewStateJson?.subStepIndex;
          if (
            advanceListviewStateJson.subChildMenuIndex ||
            advanceListviewStateJson?.subChildMenuIndex === 0
          )
            populateInside["subChildMenuIndex"] =
            advanceListviewStateJson.subChildMenuIndex;
        }
      }

      const isTabUploadedInColumn = props?.currentColumn?.includes("column") && props?.uploadedJson?.elem_type === "tab"
      const isSectionUploadedInColumn = props?.data?.insideTabColumn

      if(props?.data?.uploadedJson?.insideSectionColumn){
        delete props?.uploadedJson?.insideSectionColumn
      }
      if(props?.data?.uploadedJson?.insideTabColumn){
        delete props?.uploadedJson?.insideTabColumn
      }

      if(isTabUploadedInColumn) {
        populateInside["elem_type"] = "frame";
        populateInside["frameIndex"] = props?.data?.frameIndex;
        if(propertyName === "replace")
        populateInside["replacedElementIndex"] = props?.data?.elementIndex;
        if(populateInside["replacedFrameIndex"]){
          delete populateInside["replacedFrameIndex"]
        }
        populateInside["insideSectionColumn"] = props?.data?.insideSectionColumn;
      }

      if(isSectionUploadedInColumn){
        populateInside["insideTabColumn"] = props?.data?.insideTabColumn;
      }

      if(props?.data?.isSubForm){
        populateInside["isSubForm"] = props?.data?.isSubForm;
      }
      if(props?.data?.isAdvanceListview){
        populateInside["isAdvanceListview"] = props?.data?.isAdvanceListview
      }

      let payload = {
        populateInside: populateInside,
        // populateElem: props.data,
        populateElem: props.uploadedJson,
      };

      //  console.log(" In Import Section In Import Section ", payload);
      //  console.log(" In Import Section In Import Section ", formState2);

      var jsonToBeAdded;

      //  console.log("propertyName ",propertyName);
      const check = props?.uploadedJson?.elem_type === "frame" && props?.data?.insideSectionColumn;
      if (propertyName !== "" && !check) {
        sendRequestForControl(null, "duplicate", null, payload)
          .then((response) => {
            // console.log('Response :: ', response);
            if(response.data.populatedJson){
              let data = response.data;
              let uploadedElemType = data?.populatedJson?.elem_type;
              jsonToBeAdded = data.populatedJson;
              importedControl = props.uploadedJson.elem_type === "tab" ? "tab" : importedControl;
              jsonToBeAdded = convertElementIndex(jsonToBeAdded);
              jsonToBeAdded.insideTabColumn = props?.data?.insideTabColumn ? true : undefined
              //  convertElementIndex(jsonToBeAdded);
  
              if (jsonToBeAdded !== null) {
                updateRowNColumn(jsonToBeAdded);
                // console.log(" In Import Section In Import Section ", jsonToBeAdded);
                if(props?.data?.containerControl)
                  jsonToBeAdded["containerControl"] =  props?.data?.containerControl
                if (propertyName === "replace") {
                  if (importedControl === "tab") {
                    if(!props?.data?.insideSectionColumn){
                      jsonToBeAdded.isParentOfTab = true;
                      jsonToBeAdded.isSubForm = props?.data?.isSubForm;
                      jsonToBeAdded.isAdvanceListview = props?.data?.isAdvanceListview;

                    }
                    if(props?.data?.insideSectionColumn && jsonToBeAdded?.children?.[0])
                    jsonToBeAdded.children[0]["insideSectionColumn"] = true
                    jsonToBeAdded.ColumnLayout = "1";
                    if(uploadedElemType !== "frame")
                      jsonToBeAdded["style"] = {
                        ...ThemeJSON.section,
                      };
                    if(props?.data?.insideSectionColumn && jsonToBeAdded?.children?.[0]){
                      if (openCanvasForSubform === "subform") {
                        recursiveJsonForImportSection(
                          subFormStateJson.children[1].children,
                          props?.data?.id,
                          0,
                          subFormStateJson.children[1].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                      else if (
                        openCanvasForSubform ===
                        "advanceListviewFromScratch"
                      ) {
                        recursiveJsonForImportSection(
                          advanceListviewStateJson.children[0].children,
                          props?.data?.id,
                          0,
                          advanceListviewStateJson.children[0].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                      else{
                        recursiveJsonForImportSection(
                          formState2.children[1].children,
                          props?.data?.id,
                          0,
                          formState2.children[1].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                    }
                    else{
                      if (openCanvasForSubform === "subform") {
                        recursiveJsonForImportSection(
                          subFormStateJson.children[1].children,
                          props?.data?.frameIndex,
                          0,
                          subFormStateJson.children[1].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                      else if (
                        openCanvasForSubform ===
                        "advanceListviewFromScratch"
                      ) {
                        recursiveJsonForImportSection(
                          advanceListviewStateJson.children[0].children,
                          props?.data?.frameIndex,
                          0,
                          advanceListviewStateJson.children[0].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                      else{
                        recursiveJsonForImportSection(
                          formState2.children[1].children,
                          props?.data?.frameIndex,
                          0,
                          formState2.children[1].children,
                          jsonToBeAdded,
                          propertyName,
                          "",
                          isTabUploadedInColumn
                        );
                      }
                    }
                  } else {
                    if (openCanvasForSubform === "subform") {
                      recursiveJsonForImportSection(
                        subFormStateJson.children[1].children,
                        props?.id,
                        0,
                        subFormStateJson.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn
                      );
                    }
                    else if (
                      openCanvasForSubform ===
                      "advanceListviewFromScratch"
                    ) {
                      recursiveJsonForImportSection(
                        advanceListviewStateJson.children[0].children,
                        props?.id,
                        0,
                        advanceListviewStateJson.children[0].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn
                      );
                    }
                    else{
                      recursiveJsonForImportSection(
                        formState2.children[1].children,
                        props?.id,
                        0,
                        formState2.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn
                      );
                    }
                  }
                }
                if (propertyName === "new") {
                  if (importedControl === "tab") {
                    if(!props?.data?.insideSectionColumn){
                      jsonToBeAdded.isParentOfTab = true;
                      jsonToBeAdded.isSubForm = props?.data?.isSubForm;
                      jsonToBeAdded.isAdvanceListview = props?.data?.isAdvanceListview;

                    }
                    jsonToBeAdded.ColumnLayout = "1";
                    if(uploadedElemType !== "frame")
                      jsonToBeAdded["style"] = {
                        ...ThemeJSON.section,
                      };
                    if (openCanvasForSubform === "subform") {
                      recursiveJsonForImportSection(
                        subFormStateJson.children[1].children,
                        props?.data?.insideSectionColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=frame]`)?.getAttribute("id") : props?.data?.frameIndex,
                        0,
                        subFormStateJson.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isTabUploadedInColumn
                      );
                    }
                    else if (
                      openCanvasForSubform ===
                      "advanceListviewFromScratch"
                    ) {
                      recursiveJsonForImportSection(
                        advanceListviewStateJson.children[0].children,
                        props?.data?.insideSectionColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=frame]`)?.getAttribute("id") : props?.data?.frameIndex,
                        0,
                        advanceListviewStateJson.children[0].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isTabUploadedInColumn
                      );
                    }
                    else{
                      recursiveJsonForImportSection(
                        formState2.children[1].children,
                        props?.data?.insideSectionColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=frame]`)?.getAttribute("id") : props?.data?.frameIndex,
                        0,
                        formState2.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isTabUploadedInColumn
                      );
                    }
                  } else {
                    if (openCanvasForSubform === "subform") {
                      recursiveJsonForImportSection(
                        subFormStateJson.children[1].children,
                        props?.data?.insideTabColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=tab]`)?.getAttribute("id") : props?.id,
                        0,
                        subFormStateJson.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn,
                        props?.id
                      );
                    }
                    else if (
                      openCanvasForSubform ===
                      "advanceListviewFromScratch"
                    ) {
                      recursiveJsonForImportSection(
                        advanceListviewStateJson.children[0].children,
                        props?.data?.insideTabColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=tab]`)?.getAttribute("id") : props?.id,
                        0,
                        advanceListviewStateJson.children[0].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn,
                        props?.id
                      );
                    }
                    else{
                      recursiveJsonForImportSection(
                        formState2.children[1].children,
                        props?.data?.insideTabColumn ? document.querySelector(`#${props?.data?.style?.CustomId || props?.data?.id}`).closest(`[elem_type=tab]`)?.getAttribute("id") : props?.id,
                        0,
                        formState2.children[1].children,
                        jsonToBeAdded,
                        propertyName,
                        "",
                        isSectionUploadedInColumn,
                        props?.id
                      );
                    }
                    
                  }
                }
              }
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "success",
                alertContentKey: `${t("UploadSectionSuccessMessage")}`,
              });
              window.loading(false)

            }
              else {
              console.log("Json Is In Correct");
              showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                alertContentKey: `${t("UploadSectionErrorMessage")}`,
              });
              window.loading(false)
              // alert("Json Is In Correct");
            }
            setOpenLoader(false);
          })
          .catch((err) => {
            setOpenLoader(false);
            window.loading(false);
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: `${t('Invalid_Operation')}`
            });
          });
      }
      else {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("UploadSectionErrorMessage")}`,
        });
        window.loading(false)
      }

      props.setShowImportSectionPopUp(false);
    }

    //  recursiveJsonForImportSection(formState2.children[1].children, props.id, 0, formState2.children[1].children, jsonToBeAdded );

    // console.log(" In Import Section In Import Section ", propertyName);
    // console.log(" In Import Section In Import Section ", props.uploadedJson);
    // console.log(" In Import Section In Import Section ", formState2);
    // console.log(" In Import Section In Import Section ", props.id);
    // console.log(" In Import Section In Import Section ", formState2.children);
    //  console.log(" In Import Section In Import Section ", formState2.children[1].children);
    //  recursiveJsonForImportSection(formState2.children[1].children, props.id, 0, formState2.children[1].children, jsonToBeAdded );
  }

  function convertElementIndex(jsonData) {
    if (Array.isArray(jsonData)) {
      jsonData.forEach((item, index) => {
        if (
          item["elem_type"] === "textbox" ||
          item["elem_type"] === "textarea" ||
          item["elem_type"] === "radio" ||
          item["elem_type"] === "combo" ||
          item["elem_type"] === "checkbox" ||
          item["elem_type"] === "datepick" ||
          item["elem_type"] === "listbox" ||
          item["elem_type"] === "slider" ||
          item["elem_type"] === "toggle" ||
          item["elem_type"] === "CustomControl" ||
          item["elem_type"] === "button" ||
          item["elem_type"] === "label" ||
          item["elem_type"] === "paragraph" ||
          item["elem_type"] === "table" ||
          item["elem_type"] === "listview" ||
          item["elem_type"] === "advancelistView" ||
          item["elem_type"] === "image" ||
          item["elem_type"] === "imagecarousel" ||
          item["elem_type"] === "tab" ||
          item["elem_type"] === "iframe"
        ) {
          let elemtIndexItem = item.elementIndex.toString();
          item.elementIndex = elemtIndexItem;

          let frameIndexItem = item.frameIndex.toString();
          item.frameIndex = frameIndexItem;
        }

        if (Object.keys(item).includes("children")) {
          convertElementIndex(item);
        }
      });
    } else {
      convertElementIndex(jsonData["children"]);
    }

    return jsonData;
  }

  function removeName() {
    // props.setFileName("");
  }

  const classes = useStyles();
  return (
    <>
      <Dialog id="backdrop" className={classes.backdrop} open={true} container={() => {document.getElementById("canvasId")}}>
        <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} id="backdropDiv" className={style.backdropDivImport} >
          <header
            // style={{
            //   boxShadow: "0px 0px 1px grey",
            //   height: "36px",
            //   display: "flex",
            //   alignItems: "center",
            //   justifyContent: "space-between",
            //   padding: "0px 0px",
            //   // fontSize: "19px",
            // }}

            className={style.headerSectionStyle}
          >
            <span
              // style={{ font: "font: normal normal 600 14px/19px Open Sans" }}
              className={style.importSectionHeader}
              style={{marginRight:t("styles:importSectionStyles")}}
            >
              {/* Import{" "} */}
              {importedControl === "tab"
                ? `${t('ImportTab')}`
                : importedControl === "frame"
                ? `${t('ImportSection')}`
                : importedControl === "table" 
                ? `${t('ImportTable')}`
                : importedControl === "listview" 
                ? `${t('ImportListview')}`
                :""}
            </span>
          </header>

          <div className={style.importSectionBody} style={{marginRight:t("styles:importSectionStyles")}}>
            <div className={style.fileNameSection} style={{alignItems: "center"}}>
              <div className={style.fileNameStyle}>{props.fileName}</div>
            </div>

            <div className={style.importOptionsSection}>{t('ImportOptions')}</div>
            <div className={style.buttonsPart}>
              <Row className={style.sectionRow} style={{marginRight:t("styles:importSectionStyles")}}>
                {!props?.isTableUpload && (
                  <div
                    className={
                      propertyName !== "new"
                        ? style.firstButtonImport
                        : style.firstButtonImportAfterClick
                    }
                    onClick={() => sectionAddOrReplace("new")}
                  >
                    <div
                      className={
                        propertyName !== "new"
                          ? style.firstButtonLabel
                          : style.firstButtonLabelAfterClick
                      }
                    >
                      {/* New{" "} */}
                      {importedControl === "tab"
                        ? `${t('NewTab')}`
                        : importedControl === "frame"
                        ? `${t('NewSection')}`
                        : importedControl === "table"
                        ? `${t('NewTable')}`
                        : ""}
                    </div>
                  </div>
                )}

                <div
                  className={
                    propertyName !== "replace"
                      ? style.firstButtonImport
                      : style.firstButtonImportAfterClick
                  }
                  id={props?.data?.id + "sectionAddOrReplace"}
                  style={{width:t("styles:replaceButtonWidth")}}
                  onClick={() => sectionAddOrReplace("replace")}
                >
                  <div
                    className={
                      propertyName !== "replace"
                        ? style.firstButtonLabel
                        : style.firstButtonLabelAfterClick
                    }
                    
                  >
                    {/* Replace This{" "} */}
                    {importedControl === "tab"
                      ? `${t('ReplaceThisTab')}`
                      : importedControl === "frame"
                      ? `${t('ReplaceThisSection')}`
                      : importedControl === "table"
                      ? `${t('ReplaceThisTable')}`
                      : importedControl === "listview"
                      ? `${t('ReplaceThisListview')}`
                      : ""}
                  </div>
                </div>
              </Row>
            </div>

            <div className={style.sectionContentBackground}>
              <div className={style.sectionContent}>
                {propertyName === "new"
                  ? `${
                      importedControl === "tab"
                        ? `${t('NewTabWillBeCreated')}`
                        : importedControl === "frame"
                        ? `${t('NewSectionWillBeCreated')}`
                        : importedControl === "table"
                        ? `${t('NewTableWillBeCreated')}`
                        : ""
                    }.`
                  : propertyName === "replace"
                  ? `${
                      importedControl === "tab"
                        ? `${t('CurrentTabWillBeReplaced')}`
                        : importedControl === "frame"
                        ? `${t('CurrentSectionWillBeReplaced')}`
                        : importedControl === "table"
                        ? `${t('CurrentTableWillBeReplaced')}`
                        : importedControl === "listview"
                        ? `${t('CurrentListviewWillBeReplaced')}`
                        :""
                    }`
                  : ""}
              </div>
            </div>
          </div>

          <footer
            // style={{
            //   width: "504px",
            //   height: "50px",
            //   color: "gray",
            //   position: "absolute",
            //   bottom: "0px",
            // //   boxShadow: "0px 1px 10px grey",
            //   background: "#F5F5F5 0% 0% no-repeat padding-box",
            // }}

            className={style.footerSectionStyle}
          >
            <div
              style={{
                width: " 160px",
                float: "right",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: 'center',
                height: "100%"
              }}
            >
              {/* <div  onClick={testinghandlerImport}> */}

              {/* <span   onClick={()=>cancelImport()}>
                Cancel
                </span> */}
              {/* <div onClick={()=>testinghandlerImport()}>
                    <button onClick={()=>cancelImport()}>
                        bh
                    </button>
                    </div> */}
              <Button
              id={props?.data?.id + "cancelimport"}
              disableFocusRipple
              disableRipple
              tabIndex={0} className={`${style.cancelButton} formBuilder-MuiButton-outlined`}
                variant="outlined"
                onClick={() => cancelImport()}
              >
                {t('Cancel')}
              </Button>
              {/* </div> */}
              <Button
              id={props?.data?.id + "importbtn"}
              disableFocusRipple
              disableRipple
              tabIndex={0} className={`${style.importButton} formBuilder-MuiButton-outlined`}
                variant="contained"
                // style={{
                //   backgroundColor: "#0072c6",
                //   color: "white",
                //   width: "43px",
                //   height: "28px",
                //   fontSize: "12px",
                //   textTransform:"none",
                //   borderRadius:"2px",
                // }}
                onClick={() => importSection()}
              >
                {t('Import')}
              </Button>
            </div>
          </footer>
        </div>
      </Dialog>
    </>
  );
}
export default ImportSection;
